import React from 'react';
import FreeMobile from './free-mobile';
import BouyguesTelecom from './bouygues-telecom';
import Sfr from './sfr';
import Orange from './orange';
import Free from './free';

export const NetworkIcons = ({ networkSlug }: { networkSlug: string }) => {
  const width = 25;

  switch (networkSlug) {
    case 'SFR':
      return <Sfr width={width} />;
    case 'Orange':
      return <Orange width={width} />;
    case 'Bouygues Télécom':
      return <BouyguesTelecom width={width} />;
    case 'Bouygues Telecom':
      return <BouyguesTelecom width={width} />;
    case 'Free mobile':
      return <FreeMobile width={width} />;
    case 'Free':
      return <Free width={width} />;
    default:
      return null;
  }
};
